var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgCircleOrangeMobileMiddle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 665,
    viewBox: "0 0 239 665",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.296526,
    filter: "url(#filter0_f_5696_2648)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -104.5,
    cy: 332.5,
    rx: 207.5,
    ry: 196.5,
    fill: "url(#paint0_radial_5696_2648)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5696_2648",
    x: -447.914,
    y: 0.085907,
    width: 686.828,
    height: 664.828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 67.957,
    result: "effect1_foregroundBlur_5696_2648"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5696_2648",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-17.1383 274.852) rotate(93.7232) scale(416.456 439.578)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC36B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984226,
    stopColor: "#FFFEFD",
    stopOpacity: 0.0157744
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCircleOrangeMobileMiddle);
export default __webpack_public_path__ + "static/media/BgCircleOrangeMobileMiddle.ed68bbc9471fffc107d21b0ba5c67928.svg";
export { ForwardRef as ReactComponent };